import React, { Component } from 'react';
import TableInputHeader from './TableInputHeader';
import TableInputItem from './TableInputItem';

class TenorTable extends Component {
  state = {
    activeIndex: -1,
    dataTenor: [],
  };

  itemClicked = index => {
    const { dataTenor } = this.state;
    const { onTableChange, data } = this.props;

    if (!dataTenor[index]) {
      data[index].amount = 0;
      data[index].index = 0;
      dataTenor.push(data[index]);
    }

    onTableChange(dataTenor[index]);
    this.setState({ activeIndex: index, dataTenor });
  };

  onValueChange = value => {
    const { dataTenor, activeIndex } = this.state;
    const { onTableChange, data } = this.props;

    data[activeIndex].amount = value;
    data[activeIndex].index = activeIndex;
    if (!dataTenor[activeIndex]) {
      dataTenor.push(data[activeIndex]);
    } else {
      dataTenor[activeIndex] = data[activeIndex];
    }

    onTableChange(dataTenor[activeIndex]);
    this.setState({ dataTenor });
  };

  render() {
    const { data } = this.props;
    const { activeIndex } = this.state;
    return (
      <div>
        <TableInputHeader />
        {data.map((item, i) => {
          item.index = i;
          return (
            <TableInputItem
              key={i}
              data={item}
              activeIndex={activeIndex}
              onValueChange={e => this.onValueChange(e)}
              onClick={() => this.itemClicked(i)}
            />
          );
        })}
      </div>
    );
  }
}

export default TenorTable;
